import { Roboto_400Regular, Roboto_700Bold } from "@expo-google-fonts/roboto";
import { ApiProvider } from "@reduxjs/toolkit/query/react";
import { BugsnagContainer } from "components/bugsnag";
import { AnalyticsProvider } from "components/AnalyticsProvider";
import { AbcoClerkProvider, useUser } from "components/clerk";
import JiraIssueCollector from "components/general/JiraIssueCollector";
import LinearActivityIndicator from "components/general/LinearActivityIndicator";
import { MobileMenu } from "components/navigation";
import { Box, GluestackUIProvider } from "components/ui";
import { config } from "components/ui/gluestack-ui.config";
import { useFonts } from "expo-font";
import { Drawer } from "expo-router/drawer";
import React from "react";
import { View } from "react-native";
import { GestureHandlerRootView } from "react-native-gesture-handler";
import { MenuProvider } from "react-native-popup-menu";
import { SafeAreaView } from "react-native-safe-area-context";
import { ToastProvider } from "react-native-toast-notifications";
import { abcoApi } from "store/abcoApi";
import { ActorTokenHandler } from "utils/ActorTokenHandler";
import { FilterSettingsProvider } from "utils/hooks/useFilterSettings";
import { PopupMessageProvider } from "components/general/PopupMessageProvider";
import "../assets/global.css";
import { CheckCircle, CheckIcon } from "lucide-react-native";
import UtmHandler from "components/general/UtmHandler";

export default function MainLayout() {
	const [fontsLoaded, error] = useFonts({
		Roboto_400Regular,
		Roboto_700Bold,
		calibri: require("../assets/fonts/calibri-regular.ttf"),
		inter: require("../assets/fonts/inter.ttf"),
		raleway: require("../assets/fonts/Raleway-VariableFont_wght.ttf"),
	});
	if (!fontsLoaded) {
		return null;
	}

	return (
		<AbcoClerkProvider>
			<GluestackUIProvider config={config}>
				<PopupMessageProvider>
					<BugsnagContainer>
						<AnalyticsProvider>
							<FilterSettingsProvider>
								<MenuProvider>
									<ApiProvider api={abcoApi} setupListeners={(dispatch, getState, extra) => {
										// Configure to allow non-serializable values for file responses
										return () => {};
									}}>
										<ActorTokenHandler />
										<UtmHandler />
										<ToastProvider successIcon={<CheckCircle color="white" />}>
											<GestureHandlerRootView>
												<SafeAreaView style={{ flex: 1 }}>
													<LinearActivityIndicator />
													<Drawer
														drawerContent={() => <MobileMenu />}
														screenOptions={{
															drawerPosition: "left",
															headerShown: false,
														}}
														defaultStatus="closed"
													/>
													<JiraIssueCollector />
												</SafeAreaView>
											</GestureHandlerRootView>
										</ToastProvider>
									</ApiProvider>
								</MenuProvider>
							</FilterSettingsProvider>
						</AnalyticsProvider>
					</BugsnagContainer>
				</PopupMessageProvider>
			</GluestackUIProvider>
		</AbcoClerkProvider>
	);
}
